import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const MeetingIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Meeting</title>
    <circle cx="34" cy="16" r="2" fill="#fff"/><circle cx="26" cy="16" r="2"/><circle cx="18" cy="16" r="2"/><path d="M8,7V22H4V40l4-4H28V29h2.49L44,36.37V7Zm2,23a2,2,0,1,1,2-2A2,2,0,0,1,10,30Zm6,0a2,2,0,1,1,2-2A2,2,0,0,1,16,30Zm6,0a2,2,0,1,1,2-2A2,2,0,0,1,22,30Zm18-.37L31.51,25H28V22H12V11H40Z"/>
  </IconBase>
);
